module.exports = __webpack_public_path__ + "static/media/edit-row-icon.f071fe20.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/edit-row-icon.svg
// module id = 542
// module chunks = 1